import EcoSpace from 'eco-design/base/eco-space';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function B() {
    const { useLang } = useGlobal();
    const { t } = useLang('powerbackup');
    return (
        <div className={`power-backup-B ${css['power-backup-B']}`}>
            <EcoSpace />
            <div className="text-box ef-layer">
                <p className="title">{t('secB_title')}</p>
                <p className="desc">{t('secB_desc')}</p>
            </div>
        </div>
    );
}
